import { baseVariables, Modal, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledMyTripsModal = styled(Modal)`
  display: block;
  padding: ${toRem(10)};

  @media ${baseVariables.mediaQuery.sm} {
    padding: ${toRem(54)};
  }

  @media ${baseVariables.mediaQuery.lg} {
    padding: ${toRem(112)} ${toRem(128)};
  }

  .my-trips-modal-inner {
    max-height: none;
    bottom: auto;
    margin: 0 auto;
    padding: ${toRem(20)} 0;
    overflow: hidden;
    position: relative;

    @media ${baseVariables.mediaQuery.sm} {
      max-width: ${toRem(660)};
      padding: ${toRem(40)};
    }

    @media ${baseVariables.mediaQuery.lg} {
      max-width: ${toRem(1300)};
      padding: ${toRem(60)};
    }
  }

  .my-trips-modal-body {
    padding: 0;
    max-height: 100svh;
    @media ${baseVariables.mediaQuery.lg} {
      max-height: 63vh;
    }
  }
`;

export const StyledMyTripsModalCloseButton = styled.button`
  position: absolute;
  top: ${toRem(14)};
  right: ${toRem(14)};
  height: ${toRem(44)};
  width: ${toRem(44)};
  z-index: 200;
  cursor: pointer;
  border: none;
  background: #fff;
  padding: 0;
  border-radius: 50%;
  font-size: ${toRem(28)};
  line-height: ${toRem(28)};

  &:focus {
    outline: 2px solid #212121;
    outline-offset: ${toRem(2)};
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid #212121;
    outline-offset: ${toRem(2)};
  }

  @media ${baseVariables.mediaQuery.sm} {
    top: ${toRem(36)};
    right: ${toRem(36)};
  }

  @media ${baseVariables.mediaQuery.lg} {
    top: ${toRem(52)};
    right: ${toRem(52)};
  }
`;

export const StyledFocusSentinel = styled.span`
  position: fixed;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
